export default "__VITE_ASSET__D81XNnPt__"